<template>
  <FileDropzone @filedrop="onFileDropped">
    <div class="dt-modal--subtitle ut-mt-12px ut-ml-8px ut-mb-8px">
      {{ subtitle }}
    </div>
    <input
      type="file"
      id="filepicker"
      @change="onFilePickerChange"
      :accept="acceptedTypes"
      style="visibility: hidden; display: none"
      name="filepicker"
      :multiple="multiple"
    />
    <div class="ut-flex file-section" v-if="!this.file">
      <div class="button-container">
        <button
          class="dt-button s4 select-file"
          id="selectNewFile"
          @click="onSelectNewFile"
        >
          <div class="dt-icon-container">
            <img src="static/icons/plus.svg" class="dt-icon v7" alt />
          </div>
          <span class="button-text"> {{$t('select_new_file')}} </span>
        </button>
      </div>
      <div class="middle-or">
        <div> {{$t('word_or')}} </div>
      </div>
      <div class="file-dropzone">
        <div class="dt-icon-container">
          <img
            src="static/icons/modal/document-grey.svg"
            class="dt-icon v7"
            alt
          />
        </div>
        <span class="dropzone-text" v-if="!file"> {{$t('drag_drop')}} </span>
      </div>
    </div>
    <div class="file-upload-list">
      <div
        class="ut-flex file-upload-list-item"
        v-if="file && !fileUploadingFlag"
      >
        <div class="dt-icon-container">
          <img
            src="static/icons/modal/document-grey.svg"
            class="dt-icon v7"
            alt
          />
        </div>
        <div
          :title="file.name"
          class="file-name vermid2 txtov"
          style="max-width: 430px"
        >
          {{ file.name }}
        </div>
        <div class="dt-icon-container">
          <img
            src="static/icons/delete.svg"
            @click="(e) => onDeletePreviewFile(file)"
            class="dt-icon v7"
            alt
          />
        </div>
      </div>
      <div
        class="file-preview ut-flex"
        @click="onSelectNewFile"
        v-if="image"
        :style="
          file
            ? `
        border: 1px solid #e0e0e0;
          border-radius: 4px;
          padding: 4px;
          margin: 4px;`
            : `height: 0px; overflow: hidden`
        "
      >
        <img
          style="height: 85px; object-fit: contain"
          class="file-preview-image"
          ref="previewImage"
          alt
        />
        <div class="file-metadata ut-ml-8px ut-text-secondary">
          <div class="file-name txtov" style="max-width: 430px">
            {{ fileMetadata.name }}
          </div>
          <div class="file-size txtov" style="max-width: 430px">
            {{ fileMetadata.size }}
          </div>
          <div class="file-type txtov" style="max-width: 430px">
            {{ fileMetadata.type }}
          </div>
          <div class="file-last-modified txtov" style="max-width: 430px">
            {{ fileMetadata.lastModified }}
          </div>
        </div>
      </div>
    </div>

    <div class="ut-colcen" v-if="fileUploadingFlag" style="height: 85px">
      <div class="ut-rowcen">
        <img src="static/icons/loading.gif" alt />
      </div>
    </div>
  </FileDropzone>
</template>

<script>
import FileDropzone from "@dtplugins/file-uploader/file-dropzone";

export default {
  components: {
    FileDropzone,
  },
  props: {
    subtitle: {
      type: String,
      default: "Select a file to upload",
    },
    accept: {
      type: String,
      default: ".xls, .xlsx, .csv, .txt, .tab, .tsv",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    image: {
      type: Boolean,
      default: false,
    },
    fileUploadingFlag: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    files: null,

    filePreviews: [],
  }),
  computed: {
    file: function () {
      return this.files && this.files[0];
    },
    acceptedTypes: function () {
      return this.image ? "image/*" : this.accept;
    },
    fileMetadata() {
      // All the Metadata of the HTML File Object that is of type image
      return this.file
        ? {
            name: this.file.name,
            // Convert size to KB or MB
            size:
              this.file.size > 1024 * 1024
                ? `${(this.file.size / (1024 * 1024)).toFixed(2)} MB`
                : `${(this.file.size / 1024).toFixed(2)} KB`,
            type: this.file.type,
            lastModified: new Date(this.file.lastModified).toLocaleString(),
          }
        : {};
    },
  },
  methods: {
    onSelectNewFile: function (event) {
      document.querySelector("#filepicker").click();
    },
    onFileDropped: function (files) {
      this.files = files;
      this.emitFiles();
    },
    onFilePickerChange: function (event) {
      this.files = event.target.files;
      this.emitFiles();
    },
    emitFiles: function () {
      console.log(this.$refs["previewImage"]);
      if (this.image && this.$refs["previewImage"]) {
        this.$refs["previewImage"].src = URL.createObjectURL(this.file);
        this.$refs["previewImage"].onload = () => {
          URL.revokeObjectURL(this.$refs["previewImage"].src);
        };
      }

      // this.filePreviews = this.files?.map(file => {
      //   return {
      //     name: file.name,
      //     preview: URL.createObjectURL(file),
      //   };
      // })

      if (this.files) {
        this.$emit("files", this.files);
      }
    },
    onDeletePreviewFile(file) {
      // Remove the file from the Files Array Without using the Filter Function
      this.files = null;
    },
    //MARK: Methods
  },
};
</script>

<style>
</style>